declare global {
  interface Window {
    centerpieceapiconfig?: {
      apiBaseUrl: { [key: string]: string };
      routeNames: { [key: string]: string };
      blockAPI?: boolean;
    };
  }
}

export const routeNames = {
  // Unauth pages
  FORGOT_PASSWORD: '/a/forgot-password',
  LOGIN: '/a/login',
  REFRESH: '/a/refresh',
  SIGNUP: '/a/signup',
  RESET_PASSWORD: '/a/reset-password',
  CHANGE_PASSWORD: '/a/change-password',
  EMAIL: '/e/email',

  //General pages
  HOME: '/',
};

export const apiBaseUrl: {
  [key: string]: string;
} = {
  local: 'http://localhost:5000', //golang server
  // local: 'https://api-dev-863431118670.centerpiecehq.com',
  // local: 'https://api.centerpiecehq.com',
  development: 'https://api-dev-863431118670.centerpiecehq.com',
  production: 'https://api.centerpiecehq.com',
};

window.centerpieceapiconfig = {
  apiBaseUrl: apiBaseUrl,
  routeNames: routeNames,
};
